const branding = {
  alpha: {
    50: '#C3E7FF',
    100: '#91D3FF',
    200: '#66C2FF',
    300: '#34AEFF',
    400: '#1AA5FF',
    500: '#007DC6',
    600: '#00578A',
    700: '#0D4C77',
    800: '#0A486B',
    900: '#0C2448',
  },
  beta: {
    50: '#FFF3B8',
    100: '#FFEB85',
    200: '#FFE45C',
    300: '#FFDD31',
    400: '#EFC80C',
    500: '#FFB019',
    600: '#EB9518',
    700: '#74500B',
    800: '#553A07',
    900: '#302104',
  },
};

export const colors = {
  alpha: branding.alpha,
  beta: branding.beta,
  gamma: {},
  theta: {},
  delta: {},
  epsilon: {},
};
